"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mail = void 0;
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function Mail({ size = 20 }) {
    return (react_1.default.createElement(react_native_svg_1.default, { width: size, height: size, viewBox: "0 0 19 16" },
        react_1.default.createElement(react_native_svg_1.G, { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            react_1.default.createElement(react_native_svg_1.G, { id: "Anamnese-Splash-Screen", transform: "translate(-51.000000, -532.000000)", fill: "#1D1D1B", fillRule: "nonzero" },
                react_1.default.createElement(react_native_svg_1.G, { id: "Element-2", transform: "translate(51.000000, 532.000000)" },
                    react_1.default.createElement(react_native_svg_1.Path, { fill: "white", stroke: "white", strokeLinecap: "round", strokeWidth: "0.4", d: "M16.8095382,0 L2.19060548,0 C0.982718981,0 0,0.998184688 0,2.2250805 L0,13.7749195 C0,15.0018153 0.982718981,16 2.19060548,16 L16.8095382,16 C18.017281,16 19,15.0018153 19,13.7749195 L19,2.2250805 C19,0.998184688 18.017281,0 16.8095382,0 Z M11.8341552,7.55155396 L17.6553174,1.38394315 C17.8646787,1.60112385 17.9942901,1.8978499 17.9942901,2.2250805 L17.9942901,13.4672468 L11.8342989,7.55155396 L11.8341552,7.55155396 Z M1.34496998,1.38394315 L7.16584484,7.55155396 L1.00585361,13.4672468 L1.00585361,2.2250805 C1.00585361,1.8978499 1.13546504,1.60112385 1.34496998,1.38394315 Z M2.39637439,1.02168341 L16.6037693,1.02168341 L9.5,8.54842506 L2.39637439,1.02168341 Z M16.8095382,14.9783166 L2.19060548,14.9783166 C1.84200535,14.9783166 1.52904119,14.8236045 1.31206419,14.5792762 L7.86189554,8.28920938 L9.5,10.0249035 L11.1381045,8.28920938 L17.6879358,14.5794222 C17.4709588,14.8236045 17.1579946,14.9783166 16.8093945,14.9783166 L16.8095382,14.9783166 Z" }))))));
}
exports.Mail = Mail;
